import ENTITLEMENTS from 'enums/entitlements';
import PERMISSIONS from 'enums/permissions';
import { asBoolean } from 'functions/coercions';
import { Optional } from 'functions/promiseExtensions';
import { useJwt } from 'hooks/useJwt';

interface IProps {
	condition?: boolean;
	permissions?: PERMISSIONS[];
	entitlements?: ENTITLEMENTS[];
	children: JSX.Element[] | JSX.Element;
}

export const RenderIf = (props: IProps) => {
	if (shouldBeRendered(props)) {
		if (Array.isArray(props.children)) {
			return <>{props.children}</>;
		}
		return props.children;
	}
	return <></>;
};

export function shouldBeRendered(input: {
	condition?: boolean;
	permissions?: PERMISSIONS[];
}): boolean {
	const { arePermissionsInToken } = useJwt();
	if (input.condition !== undefined) {
		const check: boolean = asBoolean(input.condition);
		if (!check) return false;
	}
	if (input.permissions !== undefined) {
		const check: boolean = arePermissionsInToken(input.permissions);
		if (!check) return false;
	}
	return true;
}
interface IOptionalProps<T> {
	optional: Optional<T>;

	children: (t: T) => JSX.Element[] | JSX.Element;
}

export const RenderOptional = <T,>(props: IOptionalProps<T>) => {
	return props.optional.map(props.children).getOrDefault(<></>);
};
